(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/components/preamble-section.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/components/preamble-section.js');
"use strict";


const PreambleHeader = _ref => {
  let color = _ref.color;
  const _svs$widgetsCampaign$ = svs.widgetsCampaign.data.moduleConfig,
    headerTitle = _svs$widgetsCampaign$.headerTitle,
    preamble = _svs$widgetsCampaign$.preamble;
  const textColorStyle = {
    color
  };
  return headerTitle && headerTitle.length > 0 || preamble && preamble.length > 0 ? React.createElement("div", {
    className: "preamble-section-wrapper u-flex"
  }, React.createElement("div", {
    className: "preamble-section-container padding-xs-2 padding-sm-4 align-center"
  }, React.createElement("h1", {
    className: "preamble-section-header h1 margin-bottom-1",
    style: textColorStyle
  }, headerTitle), React.createElement("p", {
    className: "preamble-section-preamble margin-0",
    style: textColorStyle
  }, preamble))) : null;
};
setGlobal('svs.widgetsCampaign.components.PreambleHeader', PreambleHeader);

 })(window);